// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
import { select2RemoteAjax } from './select2_remote';

(function() {

$(document).on("turbo:load", function() {
  const initialize_matter_creditor_fields = (scope = $(document)) => scope.find('.matter-creditor-contact-select').each(function() {
    const $select = $(this);
    if ($select.data('select2')) { return; }
    // 債権者は連絡先種別30(自社側)を除く。検索条件以外は ajax_select と同じ。
    const creditor_ajax = jQuery.extend({}, ajax_select, {
      ajax: select2RemoteAjax({
        url: CONTACTS_URL,
        query: params => ({
          search_text_cont_all: params.term,
          contact_type_not_eq: 30
        })
      })
    });
    $select.select2(jQuery.extend({}, creditor_ajax, {
      placeholder: $select.data('placeholder') || '連絡先検索'
    }));
  });

  const initialize_matter_insurance_fields = (scope = $(document)) => scope.find('.matter-insurance-contact-select').each(function() {
    const $select = $(this);
    if ($select.data('select2')) { return; }
    $select.select2(jQuery.extend({}, ajax_select, {
      placeholder: $select.data('placeholder') || '連絡先検索'
    }));
  });

  const advance = $('#advance-search');
  const simple = $('#simple-search');
  $('#toggle-search').on('click', function(ev) {
    ev.preventDefault();
    const $toggle = $('#toggle-search');
    const detailedText = $toggle.data('detailed-text');
    const simpleText = $toggle.data('simple-text');
    if ($toggle.text() === detailedText) {
      $toggle.text(simpleText);
      advance.show();
    } else {
      $toggle.text(detailedText);
      advance.hide();
    }
  });

  switch_by_matter_type();

  // Get form inputs element and read i18n data attributes
  const $formInputs = $('.form-inputs');
  const placeholders = {
    mainLawyer: $formInputs.data('placeholder-main-lawyer') || '主任弁護士',
    status: $formInputs.data('placeholder-status') || '状況',
    grade: $formInputs.data('placeholder-grade') || '審級',
    courtDept: $formInputs.data('placeholder-court-dept') || '係属部',
    dept: $formInputs.data('placeholder-dept') || '部署',
    clientTypeSuffix: $formInputs.data('placeholder-client-type-suffix') || 'の属性',
    opponentType: $formInputs.data('placeholder-opponent-type') || '相手方の属性',
    documentSearch: $formInputs.data('placeholder-document-search') || '文書名検索（例:訴状）',
    contactSearch: $formInputs.data('placeholder-contact-search') || '連絡先検索',
    search: $formInputs.data('placeholder-search') || '検索',
    agentSuffix: $formInputs.data('placeholder-agent-suffix') || '代理人',
    otherPrefix: $formInputs.data('placeholder-other-prefix') || 'その他',
    addSuffix: $formInputs.data('placeholder-add-suffix') || 'の追加'
  };

  // Load client_rel from data attribute if available
  const clientRelData = $formInputs.data('client-relations');
  if (clientRelData) {
    window.client_rel = clientRelData;
  }

  if ($("#matter_user_id").is(':visible')) {
    $("#matter_user_id").select2({placeholder: placeholders.mainLawyer, allowClear: true});
  }
  $("#matter_user_ids").select2({placeholder: "  " + placeholders.mainLawyer, allowClear: true});
  $("#matter_status").select2({placeholder: placeholders.status, allowClear: true});
  $("#matter_grade").select2({placeholder: placeholders.grade});
  $('#matter_other_ids').select2(ajax_multi_select(placeholders.contactSearch));
  $('#matter_client_ids').select2(ajax_multi_select(placeholders.contactSearch));
  $('#matter_our_lawyer_ids').select2(ajax_multi_select(placeholders.contactSearch));
  $('#matter_client_insurance_ids').select2(ajax_multi_select(placeholders.contactSearch));
  $('#matter_opponent_insurance_ids').select2(ajax_multi_select(placeholders.contactSearch));
  $('#matter_client_id').select2(ajax_select);
  $('#matter_court_dept_id').select2({placeholder: placeholders.courtDept, allowClear: true});
  $('#matter_prosec_dept_id').select2({placeholder: placeholders.courtDept, allowClear: true});
  $('#matter_detention_dept_id').select2({placeholder: placeholders.dept, allowClear: true});
  const clientLabel = $('label.control-label[for="matter_client"]').data('label-text');
  $("#matter_client_type").select2({placeholder: clientLabel + placeholders.clientTypeSuffix, allowClear: true});
  $("#matter_opponent_type").select2({placeholder: placeholders.opponentType, allowClear: true});
  $('#matter_opponent_id').select2(ajax_select);
  $('#matter_opponent_lawyer_id').select2(ajax_select);
  $('#matter_secretary_ids').select2({placeholder: "", allowClear: true});
  initialize_matter_creditor_fields();
  initialize_matter_insurance_fields();

  // 文書作成部分
  $('#doc-select').select2({placeholder: placeholders.documentSearch, allowClear: true});
  $('#doc-select').on('select2:select', e => location.href = e.params.data.id);
  $('#doc-select-dropdown .dropdown-menu').on('click', e => e.stopPropagation());
  $('#doc-select-dropdown').on('click', e => $('#doc-select').val(null).trigger('change'));

  //入力ページ 依頼者の属性によるラベルの変更
  const client_type = $("#matter_client_type");
  client_type.on('change', function() {
    const rel = window.client_rel[client_type.val()];
    if (rel) {
      $("label[for='matter_opponent']").text(rel);
      $("label[for='matter_opponent_lawyer']").text(rel + placeholders.agentSuffix);
      $(".additional_opponent").text(rel + placeholders.addSuffix);
      $(".additional_opponent_lawyer").text(rel + placeholders.agentSuffix + placeholders.addSuffix);
    }
  });

  //詳細ページ 依頼者の属性によるラベルの変更
  const show_type = $("#client_type");
  if (show_type.text()) {
    const rel = window.client_rel[show_type.text()];
    if (rel) {
      $("#opponent").text(rel);
      $("#opponent_lawyer").text(rel + placeholders.agentSuffix);
      $("#opponent_ids").text(placeholders.otherPrefix + rel);
      $("#opponent_lawyer_ids").text(placeholders.otherPrefix + rel + placeholders.agentSuffix);
    }
  }


  //追加依頼者などの表示非表示
  toggle_additional_contacts('additional_client');
  toggle_additional_contacts('additional_opponent');
  toggle_additional_contacts('additional_opponent_lawyer');

  //裁判所と部署のカスケード表示
  new Select2Cascade($('#matter_court_id'), $('#matter_court_dept_id'), '/places/:parentId:/depts', place_select([10,15]));
  new Select2Cascade($('#matter_prosecution_id'), $('#matter_prosec_dept_id'), '/places/:parentId:/depts', place_select(20));
  new Select2Cascade($('#matter_detention_place_id'), $('#matter_detention_dept_id'), '/places/:parentId:/depts', place_select([40, 50, 60]))
    .then(function(parent, child, items) {
      // 部署が1つだけなら自動選択
      if (items.length === 1) {
        child.val(items[0].id).trigger('change');
      }
    });

  //相手方、裁判所、検察庁情報のToggle
  $("#opponent-panel").hide();
  const opponent_link = $("#show-opponent-panel");
  opponent_link.on('click', function() {
    $("#opponent-panel").toggle(50);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#prosecution-panel").hide();
  let court_link = $("#show-prosecution-panel");
  court_link.on('click', function() {
    $("#prosecution-panel").toggle(50);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#court-panel").hide();
  court_link = $("#show-court-panel");
  court_link.on('click', function() {
    $("#court-panel").toggle(50);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#additional-contact-panel").hide();
  let contact_link = $("#show-additional-contact-panel");
  contact_link.on('click', function() {
    $("#additional-contact-panel").toggle(50);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#our-lawyer-panel").hide();
  const our_lawyer_link = $("#show-our-lawyer-panel");
  our_lawyer_link.on('click', function() {
    $("#our-lawyer-panel").toggle(50);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#insurance-panel").hide();
  const insurance_link = $("#show-insurance-panel");
  insurance_link.on('click', function() {
    $("#insurance-panel").toggle(50);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#accident-panel").hide();
  contact_link = $("#show-accident-panel");
  contact_link.on('click', function() {
    $("#accident-panel").toggle(50);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#engagement-panel").hide();
  contact_link = $("#show-engagement-panel");
  contact_link.on('click', function() {
    $("#engagement-panel").toggle(50);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#legal-fields-panel").hide();
  const legal_fields_link = $("#show-legal-fields-panel");
  legal_fields_link.on('click', function() {
    $("#legal-fields-panel").toggle(50);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $('.matter_creditors').on('cocoon:after-insert', (e, insertedItem) => initialize_matter_creditor_fields(insertedItem));

  $('.matter-insurances').on('cocoon:after-insert', (e, insertedItem) => initialize_matter_insurance_fields(insertedItem));

  // 未入力の検索項目をパラメーターから削除 https://bit.ly/3gGh7mE
  const matter_search = document.getElementById('matter_search');
  if (matter_search) {
    matter_search.addEventListener('submit', function() {
      const allInputs = matter_search.getElementsByTagName('input');
      let i = 0;
      while (i < allInputs.length) {
        const input = allInputs[i];
        if (input.name && !input.value) {
          input.name = '';
        }
        i++;
      }
    });
  }
});

// モーダルを開くリンクが、作成後に option を差し込む先の select を伝える。
// Turbo Stream 応答は元のリンクを知らないので、クリック時に #caller-id へ残す。
$(document).on('click', '[data-for]', e => $('#caller-id').text(e.currentTarget.dataset.for));

// Default client_rel values (will be overridden by data attribute if available)
window.client_rel = {
  defendant: '原告',
  plaintiff: '被告',
  petitioner: '相手方',
  respondent: '申立人',
  creditor: '債務者',
  debtor: '債権者',
  suspect: '被害者',
  accused: '被害者',
  victim: '被疑者・被告人',
  appellant: '被控訴人',
  appellee: '控訴人',
  appellant2: '被上告人',
  appellee2: '上告人',
  claimant: '請求人',
  beclaimed: '被請求人',
  juvenile: '相手方',
  counterclaim_plaintiff: '反訴被告',
  counterclaim_defendant: '反訴原告',
  intervener: '相手方',
  assisting_intervener: '相手方',
  applicant: '被申請人',
  beapplied: '申請人'
};

const toggle_additional_contacts = function(str) {
  const input = $("#" + str);
  input.hide();
  $("#show_" + str).on('click', function(e) {
    e.preventDefault();
    input.show();
    $(this).hide();
  });
};

const switch_by_matter_type = function() {
  const matter_type = $("#matter_matter_type");
  $('#matter_opponent_ids').select2(ajax_multi_select());
  $('#matter_opponent_lawyer_ids').select2(ajax_multi_select());
};

const CONTACTS_URL = "/contacts.json";

const ajax_select = {
  language: "ja",
  allowClear: true,
  ajax: select2RemoteAjax({
    url: CONTACTS_URL,
    query: params => ({ search_text_cont_all: params.term })
  }),
  escapeMarkup(markup) { return markup; }, // let our custom formatter work
  minimumInputLength: 1
};

const ajax_multi_select = placeholderText => jQuery.extend({multiple:true, placeholder: placeholderText || '連絡先検索'}, ajax_select);

const place_select = (place_type, placeholderText) => ({
  language: "ja",
  allowClear: true,
  placeholder: placeholderText || '検索',

  ajax: select2RemoteAjax({
    url: "/places.json",
    query: params => ({ name_cont: params.term, place_type_in: place_type })
  }),

  // let our custom formatter work
  escapeMarkup(markup) { return markup; },

  minimumInputLength: 0
});

})();
